import type { CarePlanDto } from "@repo/data-store";
import { Badge } from "@repo/ui/components/ui/badge";
import type { ComponentProps } from "react";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

const STATUS_LABELS: Record<CarePlanDto["status"], string> = {
  draft: "Draft",
  active: "Active",
  "on-hold": "On hold",
  revoked: "Revoked",
  completed: "Completed",
  "entered-in-error": "Error",
  unknown: "Unknown",
};

const STATUS_VARIANTS: Record<CarePlanDto["status"], BadgeVariant> = {
  draft: "outline",
  active: "default",
  "on-hold": "secondary",
  revoked: "destructive",
  completed: "secondary",
  "entered-in-error": "destructive",
  unknown: "outline",
};

export function CarePlanStatusBadge({ status }: { status: CarePlanDto["status"] }) {
  return <Badge variant={STATUS_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
